/**
 * <s-blog-category>
 *   Category view of the blog (templates/blog.category.liquid, opened with ?view=category&category=<handle>).
 *   Liquid renders every article with data-category="<handle>"; this element shows only the requested
 *   category, fills the heading from the matching pill ([data-category-pill="<handle>"]) and marks that pill
 *   with aria-current="page". Without a category (or with an unknown one) every article stays visible.
 *     [data-category-title]  heading text to replace
 *     [data-category-count]  optional count text: "<n> <data-count-label>"
 *     [data-category-item]   article list items
 *     [data-category-empty]  shown when the category has no articles
 */
class BlogCategory extends HTMLElement {
  connectedCallback() {
    const handle = (new URLSearchParams(window.location.search).get('category') || '').toLowerCase();
    const pills = Array.from(this.querySelectorAll('[data-category-pill]'));
    const pill = pills.find((p) => p.dataset.categoryPill === handle);
    const allPill = pills.find((p) => p.dataset.categoryPill === '');
    pills.forEach((p) => p.removeAttribute('aria-current'));
    (pill || allPill)?.setAttribute('aria-current', 'page');
    if (!pill) return;

    const items = Array.from(this.querySelectorAll('[data-category-item]'));
    let shown = 0;
    items.forEach((item) => {
      const match = item.dataset.category === handle;
      item.hidden = !match;
      if (match) shown += 1;
    });

    const name = pill.dataset.categoryName || pill.textContent.trim();
    const title = this.querySelector('[data-category-title]');
    if (title) title.textContent = name;
    const count = this.querySelector('[data-category-count]');
    if (count) count.textContent = `${shown} ${count.dataset.countLabel || ''}`.trim();
    const empty = this.querySelector('[data-category-empty]');
    if (empty) empty.hidden = shown > 0;
    if (this.dataset.titleSuffix) document.title = `${name} ${this.dataset.titleSuffix}`;
  }
}

if (!customElements.get('s-blog-category')) customElements.define('s-blog-category', BlogCategory);
